<template>
  <div class="product-prices-section">
    <div class="product-quantity">
      <b-field v-if="product.actualStock === null || product.minimalQuantity <= product.actualStock" :label="$t('fields.quantity') + ':'">
        <b-numberinput
          ref="quantityInput"
          v-model.number="inputQuantity"
          :min="product.minimalQuantity"
          :max="product.actualStock !== null ? product.actualStock : 999999999"
          :disabled="product.actualStock === 0"
          controls-alignment="right"
          controls-position="compact"
          class="quantity-input product"
          type="is-white"
          expanded
          :aria-label="$t('fields.quantity')"
          :aria-plus-label="$t('cart.increaseQuantity')"
          :aria-minus-label="$t('cart.decreaseQuantity')"
          @input="checkHtml5Validity"
          @blur="checkReplaceQuantity"
        />
      </b-field>

      <b-field v-if="maxSliderQuantity !== false && (product.actualStock === null || product.minimalQuantity <= product.actualStock)">
        <b-slider :value="quantity" :min="product.minimalQuantity" :max="(product.actualStock === null || (product.actualStock !== null && product.actualStock > maxSliderQuantity )) ? maxSliderQuantity : product.actualStock" lazy @change="changeSliderQuantity" />
      </b-field>
    </div>
  </div>
</template>

<script>
import debounce from '~/marketplace-front-core/utils/debounce'
export default {
  props: {
    actualQuantity: {
      type: Number,
      required: true
    },
    maxSliderQuantity: {
      type: [Boolean, Number],
      default: false
    },
    product: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      quantity: 1,
      inputQuantity: 1,
      key: 1
    }
  },
  watch: {
    actualQuantity (quantity) {
      if (this.quantity !== quantity) {
        this.quantity = quantity
        this.inputQuantity = quantity
      }
    },
    quantity (quantity) {
      this.$emit('quantity', quantity)
    },
    inputQuantity: debounce(function (quantity) {
      this.quantity = Math.floor(Number(this.inputQuantity)) || 1
    }, 1000)
  },
  methods: {
    changeSliderQuantity (quantity) {
      const newQuantity = Math.floor(Number(quantity)) || 1
      this.quantity = newQuantity
      this.inputQuantity = newQuantity
    },
    checkHtml5Validity (quantity) {
      this.$refs.quantityInput.checkHtml5Validity()
    },
    checkReplaceQuantity (element) {
      const quantity = Math.floor(Number(this.inputQuantity)) || 1

      this.$nextTick(() => {
        const minimalQuantity = this.product.minimalQuantity >= 1 ? this.product.minimalQuantity : 1
        if (minimalQuantity > quantity) {
          this.inputQuantity = minimalQuantity
        } else if (this.product.actualStock !== null && quantity > this.product.actualStock) {
          this.inputQuantity = this.product.actualStock
        } else {
          this.inputQuantity = quantity
        }

        this.quantity = this.inputQuantity

        this.$nextTick(() => {
          this.$refs.quantityInput.checkHtml5Validity()
        })
      })
    }
  }
}
</script>
